import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  patientsCefxAConcluir: <any>[],
};


export const PatientCefxAConcluirSlice = createSlice({
  name: "patientsCefxAConcluir",
  initialState,
  reducers: {
    setpatientCefxAConcluir: (state, action: PayloadAction<any>) => {
      state.patientsCefxAConcluir = action.payload;
      // state.patientsCefxAConcluir = [...state.patientsCefxAConcluir, ...action.payload];
    },
    addPatientCefxAConcluir: (state, action: PayloadAction<any[]>) => {
      const existingIds = new Set(state.patientsCefxAConcluir.map((p) => p.id));
      const newPatients = action.payload.filter((newPatient) => !existingIds.has(newPatient.id));
      state.patientsCefxAConcluir = [...state.patientsCefxAConcluir, ...newPatients];
    },
    clearPatientCefxAConcluir: (state) => {
      state.patientsCefxAConcluir = [];
    },
  },
});

export const { setpatientCefxAConcluir, addPatientCefxAConcluir, clearPatientCefxAConcluir } = PatientCefxAConcluirSlice.actions;

export const selectPatientsCefxAConcluir = (state: any) => state.patientsCefxAConcluir || [];

export default PatientCefxAConcluirSlice.reducer;
